import * as React from "react";
import Container from "../../core/ui/container";
import Grid, { Col } from "../../core/ui/grid";
import SimpleLinkComponent from "../../core/ui/simple-link";
import FormInput from "../../core/ui/input";
import Button from "../../core/ui/button";
import HomeDataService from "../home/home.data.service";
import { resolve } from "inversify-react";
import ToastService from "../../services/toast.service";
import NavNotifier from "src/core/ui/nav-notifier";
import Divider from "src/core/ui/divider";
import images from "src/assets/images";

export interface FooterProps {
    onLogin: () => void;
    onSignUp: () => void;
    isAuthenticated: any;
}

export interface FooterState {
    /* email: string;
    emailErrors?: string[] */
}

export default class FooterView extends React.Component<FooterProps, FooterState> {
    /* @resolve
    homeDataService: HomeDataService

    @resolve
    toastService: ToastService; */

    constructor(props: FooterProps) {
        super(props);

        /* this.state = {
        email: ''
    } */
    }

    /*   handleSubscription = () => {
      this.setState({emailErrors: undefined});

    this.homeDataService.subscribe(this.state.email).then(r => {
        this.toastService.showToast("Subscription", "You have been subscribed to our newsletters", 'success')
        this.setState({email: '', emailErrors: []})
    })
    .catch(error => {
        this.toastService.showToast("Subscription", 'Oops, we got an error with your subscription', 'error');
        this.setState({emailErrors: error.email})
    })
  } */

    public render() {
        return (
            <NavNotifier idk="gray">
                <Container className="footer no-padding">
                    {/* <Grid centered>
                    <Col>
                        <SimpleLinkComponent
                            label="TRUSTED BY"
                            id="trusted_by"
                        />
                    </Col>
                </Grid> */}
                    <Grid centered fillRow className="mobile-links">
                        <Col size={40}>
                            <h6>Useful links</h6>
                            <div className="footer-links">
                                {/* Links */}
                                <a href="/">Artists</a>
                                <a href="/">Blockchain certificates</a>
                                <a href="/">Sitemap</a>
                            </div>
                        </Col>
                        <Col size={40}>
                            <h6>Information</h6>
                            <div className="footer-links">
                                {/* Links */}
                                <a href="/">Terms of use</a>
                                <a href="/">Privacy Policy</a>
                                <a href="/">legal Notice</a>
                            </div>
                        </Col>
                    </Grid>
                    <Grid centered fillRow className="mobile-links">
                        <Col size={40}>
                            <h6>Press</h6>
                            <div className="footer-links">
                                {/* Links */}
                                <a href="/"> Press release</a>
                            </div>
                        </Col>
                        <Col size={40}>
                            <h6>Contact</h6>
                            <div className="footer-links">
                                {/* Links */}
                                <a href="/">Meet the team</a>
                                <a href="/">Contact</a>
                                <a href="/">info@encryptoart.com</a>
                            </div>
                        </Col>
                    </Grid>
                    <Grid centered fillRow className="not-mobile">
                        <Col size={15}>
                            <h6>Useful links</h6>
                            <div className="footer-links">
                                {/* Links */}
                                <a href="/">Artists</a>
                                <a href="/">Blockchain certificates</a>
                                <a href="/">Sitemap</a>
                            </div>
                        </Col>
                        <Col size={15}>
                            <h6>Information</h6>
                            <div className="footer-links">
                                {/* Links */}
                                <a href="/">Terms of use</a>
                                <a href="/">Privacy Policy</a>
                                <a href="/">legal Notice</a>
                            </div>
                        </Col>
                        <Col size={15}>
                            <h6>Press</h6>
                            <div className="footer-links">
                                {/* Links */}
                                <a href="/">Press Release</a>
                            </div>
                        </Col>
                        <Col size={15}>
                            <h6>Contact</h6>
                            <div className="footer-links">
                                {/* Links */}
                                <a href="/">Meet the team</a>
                                <a href="/">Contact</a>
                                <a href="/">admin@encrypto.art</a>
                            </div>
                        </Col>
                    </Grid>
                    <Grid centered fillRow className="copyright-container">
                        <p>Encrypto Art Systems S.L. 2021 - All rights reserved</p>
                    </Grid>
                    <Grid centered>
                        <Col size={60}>
                            <Divider />
                        </Col>
                    </Grid>
                    {!this.props.isAuthenticated && (
                        <Grid centered className="not-mobile">
                            <Col size={30} className="auth-button" style={{ backgroundImage: `url('${images.loginButton}')` }}>
                                <div onClick={this.props.onLogin}>
                                    <h3>LOGIN</h3>
                                    <p>Access the blockchain experience you deserve</p>
                                </div>
                            </Col>
                            <Col size={30} className="auth-button" style={{ backgroundImage: `url('${images.registerButton}')` }}>
                                <div onClick={this.props.onSignUp}>
                                    <h3>REGISTER</h3>
                                    <p>Join the secure blockchain world</p>
                                </div>
                            </Col>
                        </Grid>
                    )}
                    <Grid centered>
                        <Col>
                            <img className="footer-logo" src={images.logoWhite} alt="" />
                        </Col>
                    </Grid>
                </Container>
            </NavNotifier>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/footer/footer.tsx